module.exports = __webpack_public_path__ + "static/media/ic-mail-sent.d77b36f1.svg";